import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { PrimeNGConfig } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NavigationHistoryService } from '@services/navigation-history.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [CommonModule, RouterOutlet, ToastModule],
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    constructor(
        private readonly primengConfig: PrimeNGConfig,
        private navigationHistory: NavigationHistoryService // Don't remove this line, it's used to inject the service
    ) {}

    /**
     * Initializes the Whole Application
     * Sets the ripple effect for PrimeNG components.
     */
    ngOnInit() {
        this.primengConfig.ripple = true;
    }
}
